


import { Gender } from './Gender';
import { CountryVM } from './CountryVM';
import { LanguageVM } from './LanguageVM';
import { CounsellingTopicVM } from './CounsellingTopicVM';
import { SessionType } from './SessionType';
import { CounsellorSearchAvailability } from './CounsellorSearchAvailability';
export class CounsellorSearchRequestVM {

  counsellorName?: string;

  gender?: Gender;

  country?: CountryVM;

  state?: string;

  language?: LanguageVM;

  counsellingTopic?: CounsellingTopicVM;

  sessionType?: SessionType;

  availability?: CounsellorSearchAvailability;

  continuationToken?: string;

}
